import React from 'react';
import { Text } from '../../components/textVariations';

export const PasswordToolTip = () => {
  return (
    <>
      <Text className="passwordPara">Adhere to password policy:</Text>
      <ul className="passwordPolicyList">
        <li>Password length should be in between 8-20 characters.</li>
        <li>
          Password should contain atleast one,
          <ul className="passwordTypeList">
            <li>Number.</li>
            <li>Capital Letter.</li>
            <li>Special Character.</li>
          </ul>
        </li>
        <li>Password shouldn't be same as previous 5 passwords.</li>
        <li>Password shouldn't contain any common words.</li>
        <li>Password shouldn't contain username or email ID.</li>
      </ul>
    </>
  );
};
